import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Box, Typography } from "@mui/material";
import * as sanitizeHtml from "sanitize-html";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from "../ThemeContext/ThemeContext.js";

// import preval from 'preval.macro';
// const buildTimestamp = preval`module.exports = new Date().toISOString();`;
// console.log(buildTimestamp)

export default function RolePermissionsDialog({
  name,
  buttonTitle,
  title,
  page,
  replacementButton,
  open,
  setopen,
}) {
  const [html, setHtml] = React.useState("");
  const { colors } = useTheme();
  const handleClose = () => {
    setopen(false);
  };

  React.useEffect(() => {
    const fn = async () => {
      const resp = await fetch(page);
      const dirty = await resp.text();
      const clean = sanitizeHtml(dirty, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([
          "head",
          "body",
          "table",
          "tr",
          "thead",
          "td",
          "img",
          "br",
          "hr",
          "area",
          "base",
          "basefont",
          "input",
          "link",
          "meta",
          "style",
        ]),
        allowedAttributes: {
          a: ["name", "target", "href"],
          img: ["src", "srcset", "alt", "title", "width", "height", "loading"],
        },
        allowedClasses: {
          "*": ["*"],
        },
        transformTags: {
          html: "div",
          head: "div",
          body: "div",
        },
        allowVulnerableTags: true,
        exclusiveFilter: function (frame) {
          if (frame.tag === "div") {
            // filter out foot notes for now
            // if (frame.attribs['class'] === 'c10' || frame.attribs['class'] === 'c19') {
            //     return true
            // }
          }
          return false;
        },
      });

      setHtml(clean);
    };
    fn();
  }, [page]);

  // Inject theme-aware CSS into the loaded HTML content
  React.useEffect(() => {
    if (html && colors) {
      const style = document.createElement('style');
      style.textContent = `
        .content {
          --bg-primary: ${colors?.background?.paper} !important;
          --bg-secondary: ${colors?.background?.default} !important;
          --bg-accent: ${colors?.background?.accent} !important;
          --bg-section: ${colors?.background?.default} !important;
          --text-primary: ${colors?.text?.primary} !important;
          --text-muted: ${colors?.text?.muted} !important;
          --text-accent: ${colors?.text?.primary} !important;
          --border-color: ${colors?.divider || '#ccc'} !important;
          --success-color: ${colors?.success?.main || colors?.primary?.main} !important;
          
          background-color: ${colors?.background?.paper} !important;
          color: ${colors?.text?.primary} !important;
          margin: 0 !important;
          padding: 2rem !important;
          width: 100% !important;
          min-height: 70vh !important;
          box-sizing: border-box !important;
        }
        .content p, .content span, .content div, .content td, .content th {
          color: ${colors?.text?.primary} !important;
        }
        .content a {
          color: ${colors?.primary?.main} !important;
        }
        .content table {
          background-color: ${colors?.background?.paper} !important;
          border: 1px solid ${colors?.divider || '#ccc'} !important;
        }
        .content th {
          background-color: ${colors?.background?.secondary} !important;
          color: ${colors?.text?.primary} !important;
          border: 1px solid ${colors?.divider || '#ccc'} !important;
        }
        .content td {
          border: 1px solid ${colors?.divider || '#ccc'} !important;
        }
        .content .section-row td {
          background-color: ${colors?.background?.secondary} !important;
          color: ${colors?.text?.primary} !important;
        }
        .content .subsection-row td {
          background-color: ${colors?.background?.accent} !important;
          color: ${colors?.text?.primary} !important;
        }
        .content .yes {
          color: ${colors?.success?.main || colors?.primary?.main} !important;
        }
        .content .no {
          color: ${colors?.text?.muted} !important;
        }
        .content .subtext {
          color: ${colors?.text?.muted} !important;
        }
        .content h1, .content h2 {
          color: ${colors?.text?.primary} !important;
        }
        .content .note {
          color: ${colors?.primary?.main} !important;
        }
        .content .note .noteMessage {
          color: ${colors?.text?.primary} !important;
        }
      `;
      document.head.appendChild(style);
      
      return () => {
        document.head.removeChild(style);
      };
    }
  }, [html, colors]);

  return (
    <div>
      <Dialog 
        maxWidth="lg" 
        fullWidth 
        open={open}
        PaperProps={{
          sx: {
            backgroundColor: colors?.background?.paper || "white",
            margin: 0,
            padding: 0,
            "& .MuiDialog-paper": {
              margin: 0,
              padding: 0,
            }
          }
        }}
      >
        <AppBar sx={{ position: "sticky", backgroundColor: colors?.primary?.main }} >
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div">
              {title}
            </Typography>
            <IconButton
              color="inherit"
              onClick={handleClose}
              autoFocus
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box 
          sx={{ 
            m: 0,
            p: 0,
            backgroundColor: colors?.background?.paper || "white",
            color: colors?.text?.primary || "black",
            minHeight: "70vh",
            width: "100%"
          }}
        >
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: html }}
            style={{
              backgroundColor: colors?.background?.paper || "white",
              color: colors?.text?.primary || "black",
              padding: "2rem",
              margin: 0,
              width: "100%",
              minHeight: "70vh",
              boxSizing: "border-box"
            }}
          ></div>
        </Box>
      </Dialog>
    </div>
  );
}
